export default{sources:{avif:"__VITE_ASSET__DC6aLsJx__ 167w",webp:"__VITE_ASSET__C2X4uAes__ 167w"},img:{src:"__VITE_ASSET__cpbFB3QR__",w:167,h:109}};